module.exports = __webpack_public_path__ + "static/media/warbrobe basic 1.c74b0e62.jpeg";